import { render, staticRenderFns } from "./LocationShiftHazardNotesDialog.vue?vue&type=template&id=dd6a7074&scoped=true&"
import script from "./LocationShiftHazardNotesDialog.vue?vue&type=script&lang=ts&"
export * from "./LocationShiftHazardNotesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6a7074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
